import { LazyLoad } from 'app/utils';

export const NewsListPage = LazyLoad(
  () => import('./index'),
  (module) => module.NewsListPage,
);
